import script from "./toast-manager.vue?vue&type=script&setup=true&lang=ts"
export * from "./toast-manager.vue?vue&type=script&setup=true&lang=ts"

import "./toast-manager.vue?vue&type=style&index=0&id=677fc658&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-677fc658"]])

export default __exports__